import {compose, createStore, applyMiddleware} from "redux";
import thunk from 'redux-thunk';
import createRootReducer from "./reducers/RootReducer";
//import analyticsMiddleware from "./middlewares/AnalyticsEvents";

export const middlewares = [thunk];

export default function configureStore(preloadedState={}) {
  return createStore(
    createRootReducer(),
    preloadedState,
    compose(
      applyMiddleware(
        ...middlewares
      ),
    )
  );
}
